﻿export function updateUpper() {
	const Upper = document.querySelector('.corp-upper__ref-header');
  const scrollTop = document.scrollingElement.scrollTop;
  if (scrollTop <= 600) {
    if (Upper.classList.contains('show')) {
      Upper.classList.remove('show');
    }
  } else {
    if (!Upper.classList.contains('show')) {
      Upper.classList.add('show');
    }
  }
}
